import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const parseMaps = (maps) => {
    const data = maps;
    const groupedData = data.reduce((acc, obj) => {
        const { id, slug, name, order, scientificName, type, cornMetric, ...rest } = obj;
        acc[slug] = acc[slug] || { id, slug, name, order, scientificName, type, versions: [], cornMetric };
        acc[slug].versions.push({ ...rest, id, cornMetric });
        return acc;
    }, {});
    return Object.values(groupedData);
};

export const getHumidityMapsFromApi = async ({ country }: { country: string }) => {
    const apiUrlHumidityMaps = new URL(`${settings.urls.apiDomain}/core/v1/maps/humidity-map/`, window.location.origin);
    const paramsHumidityMaps = new URLSearchParams();
    paramsHumidityMaps.append('country__icontains', country);
    apiUrlHumidityMaps.search = paramsHumidityMaps.toString();
    let humidityMaps = await axFetch.get(apiUrlHumidityMaps.toString());
    humidityMaps = humidityMaps.data.results.map((map, i) => ({
        ...map,
        versionNumber: i,
        type: 'humidity',
        slug: `humidity-${country}`,
        name: { en: 'Soil moisture', es: 'Humedad en el suelo', pt: 'Umidade no solo' },
        source: {
            en: `SAOCOM® Product - ©CONAE - ${new Date().getFullYear()}. All rights reserved.`,
            es: `Producto SAOCOM® - ©CONAE - ${new Date().getFullYear()}. Todos los derechos reservados.`,
            pt: `Produto SAOCOM® - ©CONAE - ${new Date().getFullYear()}. Todos os direitos reservados.`,
        },
        symptoms: {
            en: 'Integrated moisture profile in the top 50cm of soil generated from SAOCOM data and its derived surface soil moisture products. The estimates optimally combine satellite observations and values calculated with crop models.',
            es: 'Perfil de humedad integrado en los primeros 50cm de suelo generado a partir de los datos SAOCOM y sus productos derivados de humedad de suelo superficial. Las estimaciones combinan de manera óptima las observaciones satelitales y los valores calculados con modelos de cultivos.',
            pt: 'Perfil de umidade integrado nos 50 cm superiores do solo gerado a partir de dados SAOCOM e seus produtos derivados de umidade do solo superficial. As estimativas combinam de maneira ideal observações de satélite e valores calculados com modelos de culturas.',
        },
    }));
    return parseMaps(humidityMaps);
};

export const getMapsFromApi = async ({ country }: { country: string }) => {
    try {
        const apiUrl = new URL(settings.urls.apiDomain + '/core/v1/maps/map/', window.location.origin);
        const params = new URLSearchParams();
        params.append('country', country);
        apiUrl.search = params.toString();
        const res = await axFetch.get(apiUrl.toString());
        return res.data;
    } catch (error) {
        console.log(error);
        return [];
    }
};
